import { createBrowserRouter, Navigate } from "react-router-dom";
import ErrorPage from "../Pages/ErrorPage/ErrorPage";
import PrivateRoute from "./PrivateRoute";
import Login from "../Pages/Login/Login";
import NotAuthorised from "../Pages/NotAuthorised/NotAuthorised";
import UserPermissions from "../Pages/UserPermission/UserPermissions";
import Dashboard from "../Pages/AdminDashboard/Dashboard";
import ForgotPassword from "../Pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../Pages/ResetPassword/ResetPassword";
import Registration from "../Pages/Registration/Registration";
import Role from "../Pages/Role/Role";
import Home from "../Home";
import Menu from "../Pages/Menu/Menu";
import Exam from "../Pages/Exam/Exam";
import Instruction from "../Pages/Instruction/Instruction";
import Options from "../Pages/Options/Options";
import Questions from "../Pages/Questions/Questions";
import QuestionType from "../Pages/QuestionType/QuestionType";
import YearGroup from "../Pages/Year group/yearGroup";
import ExamModel from "../Pages/ExamModel/ExamModel";
import DashboardUser from "../Pages/DashboardUser/DashboardUser";
import ExamHistory from "../Pages/Exam_Histroy/Exam_History";
import ExamParticipation from "../Pages/Exam participation/Exam_participation";
import SubmitExam from "../Pages/SubmitExam/SubmitExam";
import FeedBack from "../Pages/FeedBack/FeedBack";
import ExamResult from "../Pages/ExamResult/ExamResult";
import CheckoutForm from "../Pages/CheckoutForm/CheckoutForm";
import ReViewExam from "../Pages/ReViewExam/ReViewExam";
import ReExam from "../Pages/ReExam/ReExam";
import InstructionReExam from "../Pages/InstructionReExam/InstructionReExam";
import Package from "../Pages/Package/Package";
import SubscribedPages from "../Pages/SubscribedPages/SubscribedPages";
import TotalExamList from "../Pages/TotalExamLIst/TotalExamList";
import UserProfile from "../Pages/UserProfile/UserProfile";
import InstructionPending from "../Pages/InstructionPending/InstructionPending";
import PendingExam from "../Pages/PendingExam/PendingExam";
import Purchased_Exam_List from "../Pages/Purchased_Exam_List/Purchased_Exam_List";
import User from "../Pages/User/User";
import Courses from "../Pages/Courses/Courses";
import UserAdmin from "../Pages/UserAdmin/UserAdmin";
import SubscribedUser from "../Pages/SubscribedUser/SubscribedUser";
import PracticeExam from "../Pages/PracticeExam/PracticeExam";
import InstructionPractice from "../Pages/InstructionPractice/InstructionPractice";
import InstructionPendingPractice from "../Pages/InstructionPendingPractice/InstructionPendingPractice";
import ExamResultPractice from "../Pages/ExamResultPractice/ExamResultPractice";
import SubmitExamPractice from "../Pages/SubmitExamPractice/SubmitExamPractice";
import ExamParticipationPractice from "../Pages/Exam participationPractice/Exam_participationPractice";
import PendingExamPractice from "../Pages/PendingExamPractice/PendingExamPractice";
import ReViewExamPractice from "../Pages/ReViewExamPractice/ReViewExamPractice";
import FeedBackPractice from "../Pages/FeedBackPractice/FeedBackPractice";
import InstructionPageTamplete from "../Pages/PageTamplete/InstructionPageTamplete";
import OnlineExamTamplete from "../Pages/PageTamplete/OnlineExampageTamplete/OnlineExampageTamplete";
import QuestionSubType from "../Pages/QuestionSubType/QuestionSubType";
import DashboardUserStudent from "../Pages/DashboardUserStudent/DashboardUserStudent";
import PracticeTestGrid from "../Pages/Practicepage/PracticeTestGrid";
import MockexamGrid from "../Pages/Mockexampage/MockexamGrid";
import ExamProgressGrid from "../Pages/ExamProgresspage/Examprogresspage";
import SinglePageLayout from "../Pages/Exampage/Exampage";
import VideoGrid from "../Pages/VideoPage/VideoTutorials";
import SettingsPage from "../Pages/Setting/Setting";
import GameFlow from "../Pages/Skillstrainer/GameFlow";
import MiniMockExam from "../Pages/MiniMockExampage/MIniMockExam";
import Landingpage from "../Pages/LandlingPage/Landingpage";
import DataDeletion from "../Pages/Data Deletion/DataDeletion";
import PrivacyPolicy from "../Pages/PrivacyPolicy/PrivacyPolicy";
import MemoryGame from "../Pages/Skillstrainer/Memorygame";
import SubscribedMap from "../Pages/SubscribedMap/SubscribedMap";
import SubjectMobile from "../Pages/SubjectMobile/SubjectMobile";
import ContentMobile from "../Pages/ContentMobile/ContentMobile";
import SubtopicMobile from "../Pages/SubtopicMobile/SubtopicMobile";
import Country from "../Pages/Country/Country";
import Yearlevel_map from "../Pages/Yearlevel_map/Yearlevel_map";
import InstructionPracticeReExam from "../Pages/InstructionPracticeReExam/InstructionPracticeReExam";
import ExamParticipationPracticeReExam from "../Pages/Exam participationPracticeReExam/Exam_participationPracticeReExam";
import Examdate from "../Pages/ExamDate/ExamDate";
import StudyGrid from "../Pages/StudyNote.tsx/StudyNote";
import Subject from "../Pages/StudyNote.tsx/Topic";
import SubSubject from "../Pages/StudyNote.tsx/SubTopic";
import Content from "../Pages/StudyNote.tsx/Content";
import SubTopic from "../Pages/StudyNote.tsx/SubTopic";
import Topic from "../Pages/StudyNote.tsx/Topic";
import SupportSection from "../Pages/Support/Support";
import ChatbotElliot from "../Pages/ChatWithElliot/Chatwithelliot";
import ArithmeticGame from "../Pages/Skillstrainer/ArithmeticGame";
import VideoLessions from "../Pages/VideoLessons/videoLessons";
import VideoLessonsDashboard from "../Pages/VideoLessonsDashboard/subject/VideoLessonsDashboard";
import UserVideoLessonDetail from "../Pages/UserVideoLessonDetail/UserVideoLessonDetail";
import VideoLessonsTopic from "../Pages/VideoLessonsDashboard/topic/VideoLessonsTopic";
import ReadingComprehensionUI from "../Pages/UserVideoLessonDetail/UserVideoLessonDetail";
import StudyMaterials from "../.MODULS/BOOKLET_MODUL/Pages/StudyMaterial/StudyMaterial";
import Layout from "../.MODULS/BOOKLET_MODUL/Components/Layout/Layout";
import StudyMaterialsTopic from "../.MODULS/BOOKLET_MODUL/Pages/StudyMaterialTopic/StudyMaterialTopic";
import StudyMaterialSubTopic from "../.MODULS/BOOKLET_MODUL/Pages/StudyMaterialSubTopic/StudyMaterialSubTopic";
import CartPage from "../.MODULS/BOOKLET_MODUL/Pages/CartPage/Cartpaage";
import MyRequest from "../.MODULS/BOOKLET_MODUL/Pages/My_request/Myrequest";
import RequestDetail from "../.MODULS/BOOKLET_MODUL/Pages/My_request_Details/Myrequest_details";
import ClassSelection from "../.MODULS/BOOKLET_MODUL/Pages/ClassSelection/ClassSelection";
import LessonPlan from "../.MODULS/BOOKLET_MODUL/Pages/LessonPlan/LessonPlan";
import BookletRequest from "../.MODULS/BOOKLET_ADMIN_MODUL/BookletRequest/Booklet_Request";
import BookletRequestDetail from "../.MODULS/BOOKLET_ADMIN_MODUL/BookletRequestdetails/BookletRequestDetails";
import Center from "../.MODULS/BOOKLET_ADMIN_MODUL/Master/Center/Center";
import Printer from "../.MODULS/BOOKLET_ADMIN_MODUL/Master/Printer/Printer";
import CenterPrinter from "../.MODULS/BOOKLET_ADMIN_MODUL/Master/Center_Printer/CenterPrinter";
import Tutor from "../.MODULS/BOOKLET_ADMIN_MODUL/Master/Tutors/Tutors";
import PolicyTemplate from "../Pages/PolicyTemplates/PolicyTemplate";
import TermsandConditions from "../Pages/Terms and Services/Terms_and_services";
import LandingLayout from "../Components/LandingLayout/LandingLayout";
import SubjectDriveMap from "../.MODULS/BOOKLET_ADMIN_MODUL/Master/SubjectDriveMapping/SubjectDriveMap";
import ClassSelectionMaster from "../.MODULS/BOOKLET_ADMIN_MODUL/Master/ClassSelection/ClassSelectionMaster";
import TutorDashboard from "../.MODULS/BOOKLET_MODUL/Pages/TutorDashboard/Tutordashboard";
import AdminDashboard from "../.MODULS/BOOKLET_ADMIN_MODUL/Dashboard/Dashboard";
import AuthRoute from "./AuthRoute";
import Lead from "../.MODULS/CRM_MODUL/pages/Lead/Lead";
import CRMDashboard from "../.MODULS/CRM_MODUL/pages/Dashboard/Dashboard";
import GateAdminDashboard from "../Pages/AdminDashboard/Admindashboard";
import Session from "../.MODULS/CRM_MODUL/pages/Session/Session";
import Histroy from "../.MODULS/BOOKLET_ADMIN_MODUL/Histroy/Histroy";
import { UcatInstructionsScreen } from "../.MODULS/UCAT_EXAM_MODUL/Pages/InstructionScreen/TestInstructionScreen";
import UcatPracticeExam from "../.MODULS/UCAT_EXAM_MODUL/Pages/UCAT_Exam/Practice_Test/Practicetest";
import UcatTestScreen from "../.MODULS/UCAT_EXAM_MODUL/Pages/UCAT_Test/UcatTestScreen";
import UcatPendingTestScreen from "../.MODULS/UCAT_EXAM_MODUL/Pages/UCAT_Test/UcatPendingTestScreens";
import UcatRetakeTestScreen from "../.MODULS/UCAT_EXAM_MODUL/Pages/UCAT_Test/UcatRetakeTestScreens";
import { UcatResultScreen } from "../.MODULS/UCAT_EXAM_MODUL/Pages/TestResultScreen/TestResultScreen";
import { TestSummaryScreen } from "../.MODULS/UCAT_EXAM_MODUL/Pages/TestSummaryScreen/TestSummaryScreen";
import UcatWelcomeScreen from "../.MODULS/UCAT_EXAM_MODUL/Pages/WelcomeScreen/ucat_welcome_screen";
// Start Test
import UcatStartTest from "../.MODULS/UCAT_EXAM_MODUL/Pages/UCAT_Exam/StartTest/UcatStartTest";
// Pending Test
import UcatPendingTest from "../.MODULS/UCAT_EXAM_MODUL/Pages/UCAT_Exam/PendingTest/UcatPendingTest";
// Retake Test
import UcatRetakeTest from "../.MODULS/UCAT_EXAM_MODUL/Pages/UCAT_Exam/RetakeTest/UcatRetakeTest";
import UcatExamRules from "../.MODULS/UCAT_EXAM_MODUL/Pages/WelcomeScreen/ucat_exam_rules";
import UcatExamSupport from "../.MODULS/UCAT_EXAM_MODUL/Pages/WelcomeScreen/ucat_exam_support";
import UcatAgreement from "../.MODULS/UCAT_EXAM_MODUL/Pages/WelcomeScreen/ucat_agreement";

import UCAT_TestPage from "../Pages/Ucat_test/UcatTest_Grid";
import ScreenMaster from "../Pages/ScreenMaster/ScreenMaster";
import RoleMappingMaster from "../Pages/RoleMappingMaster/RoleMappingMaster";
import { UcatTestReview } from "../.MODULS/UCAT_EXAM_MODUL/Pages/ReviewScreen/UcatTestReview";
import RoleScreenYGPermissionPage from "../Pages/RoleScreenYGPermission/RoleScreenYGPermissionPage";
import EndExamScreen from "../.MODULS/UCAT_EXAM_MODUL/Pages/EndExamScreens/EndExamScreens";

import { UcatPracticeTestWelcomeScreen } from "../.MODULS/UCAT_EXAM_MODUL/Pages/UCAT_Test/WelcomeScreen";
import { UcatTestInstructions } from "../.MODULS/UCAT_EXAM_MODUL/Pages/UCAT_Test/TestInstructon";

import UcatExamTemplate from "../Pages/Questions/UcatExamTemplate";
import SmartExam from "../Pages/SmartExam/SmartExam";
import SmartExamDashboard from "../Pages/SmartExam/SmartExamDashboard";

const DomainRedirect = () => {
  const isUcat =
    window.location.hostname.toLowerCase().includes("ucat") ||
    // window.location.hostname.toLowerCase().includes("192") ||
    window.location.hostname.toLowerCase().includes("ucattest");

  if (isUcat) {
    return <Navigate to="/login" replace />;
  }
  return <Landingpage />;
};

export const router = createBrowserRouter([
  { path: "/home", element: <DomainRedirect /> },
  { path: "/", element: <DomainRedirect /> },
  { path: "/login", element: <Login /> },
  { path: "/datadeletion", element: <DataDeletion /> },
  { path: "/registration", element: <Registration /> },
  { path: "/forgotPassword", element: <ForgotPassword /> },
  { path: "/datadeletion", element: <DataDeletion /> },
  { path: "/resetPassword", element: <ResetPassword /> },
  { path: "/sm_exam/practice", element: <PrivateRoute element={<SmartExam />} /> },

  {
    path: "/",
    element: <AuthRoute />,
    children: [
      {
        path: "/instructionpagetamplete",
        element: <InstructionPageTamplete />,
      },
      { path: "/onlineexamtamplete", element: <OnlineExamTamplete /> },
      { path: "/ucatexamtemplate", element: <UcatExamTemplate /> },
      // appbar
      { path: "/instruction", element: <Instruction /> },
      { path: "/examparticipation", element: <ExamParticipation /> },
      { path: "/submitexampractice", element: <SubmitExamPractice /> },
      { path: "/instructionpractice", element: <InstructionPractice /> },
      { path: "/pendingexampractice", element: <PendingExamPractice /> },
      {
        path: "/instructionpendingpractice",
        element: <InstructionPendingPractice />,
      },
      { path: "/subscribedPages", element: <SubscribedPages /> },
      { path: "/instructionpending", element: <InstructionPending /> },
      { path: "/pendingexam", element: <PendingExam /> },
      { path: "/submitexampractice", element: <SubmitExamPractice /> },
      { path: "/submitexam", element: <SubmitExam /> },
      { path: "/feedback", element: <FeedBack /> },
      { path: "/feedbackpractice", element: <FeedBackPractice /> },
      { path: "/reviewexam", element: <ReViewExam /> },
      { path: "/reviewexampractice", element: <ReViewExamPractice /> },
      { path: "/reexam", element: <ReExam /> },
      { path: "/reexaminstruction", element: <InstructionPracticeReExam /> },
      { path: "/instructionreExam", element: <InstructionReExam /> },
      { path: "/practiceexam", element: <ExamParticipationPractice /> },
      { path: "/welcome_ucat", element: <UcatWelcomeScreen /> },
      { path: "/ucat_start_exam", element: <UcatStartTest /> },
      { path: "/ucat_pending_exam", element: <UcatPendingTest /> },
      { path: "/ucat_retake_exam", element: <UcatRetakeTest /> },

      // { path: "/ucat_welcome_screen", element: <UcatWelcomeScreen /> },
      { path: "/ucat_agreement", element: <UcatAgreement /> },
      { path: "/ucat_exam_rules", element: <UcatExamRules /> },
      { path: "/ucat_exam_support", element: <UcatExamSupport /> },

      { path: "/ucat_exampractice_instruction", element: <UcatInstructionsScreen /> },
      { path: "/ucat_exam_general_instruction", element: <UcatInstructionsScreen /> },
      { path: "/ucat_exam_practice", element: <UcatPracticeExam /> },
      { path: "/ucat_examsummary_practice", element: <TestSummaryScreen /> },
      { path: "/ucat_examresult_practice", element: <UcatResultScreen /> },
      { path: "/ucat_testevaluation", element: <TestSummaryScreen /> },
      { path: "/ucat_test_review", element: <UcatTestReview /> },
      { path: "/ucat_end_exam", element: <EndExamScreen /> },
      {
        path: "/practiceexamreexam",
        element: <ExamParticipationPracticeReExam />,
      },
      { path: "/examresultpractice", element: <ExamResultPractice /> },
      { path: "/examresult", element: <ExamResult /> },

      { path: "/ucat_test_screen", element: <UcatTestScreen /> },
      { path: "/ucat_pending_test_screen", element: <UcatPendingTestScreen /> },
      { path: "/ucat_retake_test_screen", element: <UcatRetakeTestScreen /> },
      { path: "/ucat_practice_test", element: <UcatPracticeTestWelcomeScreen /> },
      { path: "/ucat_test_instructions", element: <UcatTestInstructions /> },


    ],
  },

  {
    path: "/",
    element: <LandingLayout />,
    children: [
      { path: "/privacypolicy", element: <PrivacyPolicy /> },
      { path: "/termsandservices", element: <TermsandConditions /> },
    ],
  },

  {
    path: "/",
    errorElement: <ErrorPage />,
    // loader:,

    element: <PrivateRoute element={<Home />} />,
    // element: <Home />,
    children: [
      {
        path: "admindashboard",
        element: <GateAdminDashboard />,
      },

      {
        path: "userprofile",
        children: [
          {
            path: "student",
            element: <User />,
          },
          {
            path: "staff",
            element: <UserAdmin />,
          },
          {
            path: "subscribed_user",
            element: <SubscribedUser />,
          },
        ],
      },

      {
        path: "masters",
        children: [
          {
            path: "exam",
            element: <Exam />,
          },
          {
            path: "Instruction",
            element: <Instruction />,
          },
          {
            path: "options",
            element: <Options />,
          },
          {
            path: "questions",
            element: <Questions />,
          },
          {
            path: "questiontype",
            element: <QuestionType />,
          },
          {
            path: "template",
            element: <PolicyTemplate />,
          },
          {
            path: "yeargroup",
            element: <YearGroup />,
          },
          {
            path: "video_upload",
            element: <VideoLessions />,
          },
          {
            path: "questionsubtype",
            element: <QuestionSubType />,
          },
          {
            path: "practiceexam",
            element: <PracticeExam />,
          },
          {
            path: "exammodel",
            element: <ExamModel />,
          },
          { path: "package", element: <Package /> },
          { path: "courses", element: <Courses /> },
          { path: "assignpackage", element: <SubscribedMap /> },
          { path: "subject", element: <SubjectMobile /> },
          { path: "content", element: <ContentMobile /> },
          { path: "country", element: <Country /> },
          { path: "yearlevel", element: <Yearlevel_map /> },

          { path: "subtopic", element: <SubtopicMobile /> },
          { path: "examdate", element: <Examdate /> },
        ],
      },

      {
        path: "settings",
        children: [
          {
            path: "role",
            element: <Role />,
          },
          {
            path: "menu",
            element: <Menu />,
          },
          {
            path: "screen",
            element: <ScreenMaster />,
          },
          // {
          //   path: "screen",
          //   element: <ScreenMaster />,
          // },
          {
            path: "role-mapping-master",
            element: <RoleMappingMaster />,
          },
          {
            path: "userPermission",
            element: <UserPermissions />,
          },
          {
            path: "role_permission",
            element: <RoleScreenYGPermissionPage />,
          },
        ],
      },

      { path: "/support", element: <SupportSection /> },
      { path: "/skillstrainer", element: <GameFlow /> },
      { path: "/dashboard", element: <DashboardUserStudent /> },
      { path: "/practicetest", element: <PracticeTestGrid /> },
      { path: "/studynote", element: <StudyGrid /> },
      { path: "/topic", element: <Topic /> },
      { path: "/subtopic", element: <SubTopic /> },
      { path: "/content", element: <Content /> },
      { path: "/minimockexam", element: <MockexamGrid /> },
      { path: "/mockexam", element: <MiniMockExam /> },
      { path: "/ucat_test", element: <UCAT_TestPage /> },
      { path: "/examprogress", element: <ExamProgressGrid /> },
      { path: "/mainexam", element: <SinglePageLayout /> },
      { path: "/examhistory", element: <ExamHistory /> },
      { path: "/totalexam", element: <TotalExamList /> },
      { path: "/studentprofile", element: <UserProfile /> },
      { path: "/tutorials", element: <VideoGrid /> },
      { path: "/setting", element: <SettingsPage /> },
      { path: "/chatbotelliot", element: <ChatbotElliot /> },
      { path: "/purchasedexam", element: <Purchased_Exam_List /> },
      { path: "/arithmetic-game", element: <ArithmeticGame /> },
      { path: "/memorygame", element: <MemoryGame /> },
      { path: "/videolessons", element: <VideoLessonsDashboard /> },
      { path: "/videolessonstopic", element: <VideoLessonsTopic /> },
      { path: "/videolessondetails", element: <ReadingComprehensionUI /> },
      { path: "/booklet", element: <ReadingComprehensionUI /> },
      { path: "/sm_exam", element: <SmartExamDashboard /> },

      {
        path: "NotAuthorised",
        element: <NotAuthorised />,
      },
      { path: "/payment", element: <CheckoutForm /> },
    ],
  },

  {
    path: "/",
    element: <PrivateRoute element={<Home />} />,
    children: [
      {
        path: "/tutor_dashboard",
        element: <TutorDashboard />,
      },
      {
        path: "/study_materials",
        element: <StudyMaterials />,
      },
      {
        path: "/study_materials/topic",
        element: <StudyMaterialsTopic />,
      },
      {
        path: "/study_materials/sub-topic",
        element: <StudyMaterialSubTopic />,
      },
      {
        path: "/study_materials/cart",
        element: <CartPage />,
      },

      {
        path: "/my_requests",
        element: <MyRequest />,
      },
      {
        path: "/my_requests/request_details",
        element: <RequestDetail />,
      },
      {
        path: "class_selection",
        element: <ClassSelection />,
      },
      {
        path: "history",
        element: <Histroy />,
      },
      {
        path: "/lesson_plan",
        element: <LessonPlan />,
      },
    ],
  },

  {
    path: "/",
    element: <PrivateRoute element={<Home />} />,
    children: [
      {
        path: "tutor_admin_dashboard",
        element: <AdminDashboard />,
      },
      {
        path: "booklet_request",
        element: <BookletRequest />,
      },
      {
        path: "Booklet_history",
        element: <Histroy />,
      },
      {
        path: "booklet_request/details",
        element: <BookletRequestDetail />,
      },

      {
        path: "masters/center",
        element: <Center />,
      },
      {
        path: "masters/center_printer",
        element: <CenterPrinter />,
      },
      {
        path: "masters/printer",
        element: <Printer />,
      },
      {
        path: "masters/subject_drive_map",
        element: <SubjectDriveMap />,
      },
      {
        path: "masters/class_selection",
        element: <ClassSelectionMaster />,
      },
      {
        path: "masters/tutors",
        element: <Tutor />,
      },
    ],
  },

  {
    path: "/",
    element: <PrivateRoute element={<Home />} />,
    children: [
      {
        path: "crm_dashboard",
        element: <CRMDashboard />,
      },
      {
        path: "leads",
        element: <Lead />,
      },
      {
        path: "session",
        element: <Session />,
      },
    ],
  },
]);
